import React from "react";

const ThankYou = () => {
  return (
    <>
      <h2 className="page__heading">Thank you for your booking request</h2>
      <p className="align--center">
        One of our technicians will be in touch with you shortly.
      </p>
    </>
  );
};

export default ThankYou;
